import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
import t from '@jetshop/intl';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import get from 'lodash.get';
import React from 'react';
import styled from 'react-emotion';
import { ReactComponent as Cross } from '../svg/Cross.svg';
export const FilterGroup = styled('div') `
  font-size: 0.875rem;
`;
const Label = styled('label') `
  font-weight: 300;
  padding-right: 0.25rem;
  text-transform: capitalize;
`;
const Value = styled('span') `
  font-weight: 600;
  padding-right: 1rem;
`;
export const AppliedFilter = styled('button') `
  background: black;
  color: white;
  border: 0;
  padding: 0.5rem;
  margin: 0.5rem;
  display: inline-flex;
`;
export const FilterWrapper = styled('aside') `
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.5rem;
`;
export const ClearButton = styled('button') `
  background: none;
  text-decoration: underline;
  margin-left: 0.5rem;
  :hover,
  :focus {
    opacity: 0.8;
    outline: none;
  }
`;
const ActiveListFilters = ({ filters, className }) => (React.createElement(ErrorBoundary, { component: PassThrough },
    React.createElement(FilterContext.Consumer, null, ({ activeFilters, clearListFilter, clearFilters }) => {
        const appliedListFilters = activeFilters.listFilters
            .map(listFilter => {
            const active = filters.find(f => {
                return (stripCategoryId(f.id) === listFilter.id ||
                    f.id === listFilter.id);
            });
            return active;
        })
            .filter(Boolean);
        if (appliedListFilters.length === 0)
            return null;
        return (React.createElement(FilterWrapper, { className: className },
            activeFilters.listFilters.map(activeListFilter => {
                // Get the displayname from the full filter object passed in via props
                const activeFilter = filters.find(f => stripCategoryId(f.id) === activeListFilter.id ||
                    f.id === activeListFilter.id);
                if (!activeFilter)
                    return null;
                const filterName = activeFilter.name;
                return (React.createElement(FilterGroup, { key: activeListFilter.id }, activeListFilter.values.map(value => (React.createElement(AppliedFilter, { type: "button", key: value + activeListFilter.id, onClick: () => clearListFilter(activeListFilter.id, value) },
                    React.createElement(Label, null,
                        filterName,
                        " "),
                    React.createElement(Value, null, get(activeFilter.items.find(item => item.value === value), 'text')),
                    React.createElement(Cross, null))))));
            }),
            React.createElement(ClearButton, { type: "button", onClick: () => clearFilters() }, t('Clear all filters'))));
    })));
export default ActiveListFilters;
//# sourceMappingURL=ActiveFilters.js.map